import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../config/const";
import Controls from "../components/controls/Controls";
import {
  Typography,
  Paper,
  Toolbar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
} from "@material-ui/core";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const Presensi = () => {
  const now = new Date(Date.now());
  const [dateRanges, setDateRanges] = useState([
    new Date(now.getFullYear(), now.getMonth(), 1),
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  ]);
  const [presensiToko, setPresensiToko] = useState([]);
  const [toko, setToko] = useState("PADM");
  const [listToko, setListToko] = useState([]);

  const columns = [
    {
      field: "staff",
      headerName: "Staff",
      width: 120,
    },
    {
      field: "toko",
      headerName: "Toko",
      width: 120,
    },
    {
      field: "role",
      headerName: "Jabatan",
      width: 175,
    },
    {
      field: "tanggal",
      headerName: "Tanggal",
      width: 175,
      valueGetter: (params) =>
        new Date(params.row.tanggal).toLocaleDateString("en-CA"),
    },
    {
      field: "checkin",
      headerName: "Jam Check In",
      width: 175,
    },
    {
      field: "checkout",
      headerName: "Jam Check Out",
      width: 175,
    },
    {
      field: "imageurl",
      headerName: "Selfie",
      width: 750,
      renderCell: (params) => (
        <Link rel="noopener noreferred" href={params.value} target="_blank">
          {params.value !== null ? params.value.toString() : ""}
        </Link>
      ),
    },
  ];

  const getPresensi = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(`${baseUrl}/getPresensi`, {
        params: {
          startDate: dateRanges[0].toLocaleDateString("en-CA"),
          endDate: dateRanges[1].toLocaleDateString("en-CA"),
          toko,
        },
      });
      console.log(presensiToko);
      setPresensiToko(data.map((item, index) => ({ id: index, ...item })));
    } catch (error) {
      console.error(error);
    }
  };

  const getListKasir = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(`${baseUrl}/getAllToko`);

      setListToko(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getPresensi();
  }, [toko, dateRanges]);

  useEffect(() => {
    getListKasir();
  }, []);

  return (
    <>
      <Typography variant="h3">Presensi Staff Toko</Typography>
      <Paper style={{ height: 600, padding: 20, marginTop: 20 }}>
        <Box style={{ display: "flex" }}>
          <Toolbar style={{ alignItems: "center" }}>
            <Controls.Label label="Pilih Toko: " />
            <Controls.Select
              name="toko"
              value={toko}
              noneLabel={"All"}
              onChange={(e) => {
                setToko(e.target.value);
              }}
              otherStyle={{
                marginBottom: 0,
                marginLeft: 10,
              }}
              options={listToko.map(({ name, role }) => {
                return {
                  id: name,
                  name: name,
                };
              })}
            />
          </Toolbar>
          <Toolbar>
            <Controls.Label label="Select date: " />
            <Box style={{ width: 10 }} />
            <Controls.DateRangeCustomPicker
              name="date-range"
              setDates={setDateRanges}
              dateRanges={dateRanges}
            />
          </Toolbar>
        </Box>
        <Box style={{ marginBottom: 10 }} />
        <DataGrid
          columns={columns}
          rows={presensiToko}
          components={{ Toolbar: GridToolbar }}
          checkboxSelection
          disableSelectionOnClick
          style={{ minHeight: 450, height: "auto" }}
        />
      </Paper>
    </>
  );
};

export default Presensi;
